export default __webpack_public_path__ + "static/media/b&a-man.8d4d73f9.png";